
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
// import ExtraNews from "@/components/ExtraNews.vue";
import { Component, Vue } from "vue-property-decorator";

import "@/assets/css/vendor.css";
import "@/assets/css/style.css";

@Component({
  components: { Header, Footer /*, ExtraNews*/ },
})
export default class extends Vue {}
